<template>
  <v-col class="pa-0">
    <v-card
      class="px-6 py-2 elevation-0"
    >
      <v-row class="flex-nowrap">
        <v-col class="col-grow">
          <v-card-title :class="`subtitle-1 ${titleColor}--text font-weight-bold pl-0 pt-2 pb-3`">
            <span>
              {{ (contact && contact.personName) || 'Contacts' }}
            </span>
          </v-card-title>

          <v-card-subtitle class="pa-0 caption">
            {{ contact && contact.personName ? 'Your Main Contact' : 'The people important to you.' }}
          </v-card-subtitle>
        </v-col>

        <v-col class="col-auto px-0">
          <v-card-actions
            v-if="contact && contact.href"
            class="pl-3"
          >
            <v-btn
              color="darkblue"
              icon
              small
              :to="contact.href"
            >
              <v-icon>
                person
              </v-icon>
            </v-btn>
          </v-card-actions>
        </v-col>
      </v-row>

      <v-row class="pb-2 mt-0">
        <v-col>
          <v-card-text class="pl-3">
            <v-row v-if="contact">
              <v-skeleton-loader
                v-if="!contact && !contact.email"
                type="text"
              />

              <router-link
                v-else
                :to="contact.href"
                class="text-decoration-none"
              >
                <span>
                  {{ contact.email }}
                </span>
              </router-link>
            </v-row>

            <v-row v-else>
              <v-col class="px-0 caption">
                <span>Coming Soon</span>
              </v-col>
            </v-row>
          </v-card-text>
        </v-col>
      </v-row>
    </v-card>
  </v-col>
</template>

<script>
import { createNamespacedHelpers } from 'vuex'

const { mapGetters: mapLayoutGetters } = createNamespacedHelpers('layout')
const { mapGetters: mapToolsGetters } = createNamespacedHelpers('tools')

export default {
  name: 'ContactCard',
  computed: {
    ...mapLayoutGetters(['titleColor']),
    ...mapToolsGetters(['mainContact']),
    contact() {
      return this.mainContact
    },
  },
  methods: {
    goToManagerProfile(contact) {
      this.$router.push(contact.href)
    },
  },
}
</script>
